import type React from 'react';
import { useParams } from 'react-router-dom';
import { useDrawers } from '../../drawers/all-drawers.tsx';
import { IdAndNameCell } from './id-and-name-cell.tsx';

type Props = {
    erpProductId: string | null | undefined;
    productName: string | null | undefined;
    onClick?: () => void;
    className?: string;
    topClassName?: string;
    bottomClassName?: string;
};

export const ProductLinkCell: React.FC<Props> = ({
    erpProductId,
    productName,
    onClick,
    className,
    bottomClassName,
    topClassName,
}) => {
    const { openProductDetails } = useDrawers();
    const params = useParams<{ customer_id: string }>();

    return (
        <IdAndNameCell
            to={`/inventory/${erpProductId}`}
            id={erpProductId}
            title={productName ?? ''}
            onClick={() => {
                if (erpProductId) {
                    onClick?.();
                    openProductDetails(erpProductId, params.customer_id || '');
                }
            }}
            className={className}
            bottomClassName={bottomClassName}
            topClassName={topClassName}
        />
    );
};
